import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { applyTrackingConsent, trackPageView } from "../util/tracking";

export function useTrackingPageViews() {
  const location = useLocation();

  useEffect(() => {
    applyTrackingConsent();
  }, []);

  useEffect(() => {
    const path = `${location.pathname}${location.search}${location.hash}`;
    trackPageView(path);
  }, [location.pathname, location.search, location.hash]);

  useEffect(() => {
    const handleConsentChange = () => {
      const path = `${window.location.pathname}${window.location.search}${window.location.hash}`;
      window.setTimeout(() => trackPageView(path), 0);
    };

    window.addEventListener("stuCookieConsentChanged", handleConsentChange);

    return () => {
      window.removeEventListener("stuCookieConsentChanged", handleConsentChange);
    };
  }, []);
}
